// src/components/AdminGuard.tsx

import { Navigate, Outlet } from 'react-router-dom';
import { useAppStore } from '../store/appStore';
import { isAdmin } from '../utils/adminUtils';

export function AdminGuard() {
  const session = useAppStore((state) => state.session);

  if (!session || !isAdmin(session.idToken)) {
    return <Navigate to="/years" replace />;
  }

  return <Outlet />;
}
